import { getPatientPharmaciesByUserId } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PatientPharmacyT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPatientPharmaciesByUserId(
  userId: string,
  signal?: AbortSignal
): Promise<PatientPharmacyT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPatientPharmaciesByUserId(userId, config);
  return lotusHealthZod.getPatientPharmaciesByUserIdResponse.parse(
    response.data
  ) as PatientPharmacyT[];
}
